import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { Navbar2Component } from './layout/navbar-2/navbar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { filter } from 'rxjs/operators';
import { WHATSAPP_CONFIG } from './config/whatsapp.config';

declare global {
  interface Window { whatsAppNumber: string; }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, NavbarComponent, Navbar2Component, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'consorcio-site';

  // Rotation logic moved here for SPA consistency
  private rotationNumbers = WHATSAPP_CONFIG.numbers;
  private currentRotatedNumber: string = '';

  constructor(private router: Router) {
    // If window.whatsAppNumber is already set (by index.html), use it as the session rotation number.
    // Otherwise, pick a new one.
    if (typeof window !== 'undefined' && window.whatsAppNumber && this.rotationNumbers.includes(window.whatsAppNumber)) {
      this.currentRotatedNumber = window.whatsAppNumber;
    } else {
      const randomIndex = Math.floor(Math.random() * this.rotationNumbers.length);
      this.currentRotatedNumber = this.rotationNumbers[randomIndex];
    }
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateWhatsAppNumber(event.url);
    });
  }

  updateWhatsAppNumber(url: string) {
    const isFixedNumberPage = url.includes('imoveis-2') || url.includes('veiculos-2');

    if (isFixedNumberPage) {
      window.whatsAppNumber = '5511985256688'; // LUIZ FIXO
    } else {
      // Restore rotation number
      window.whatsAppNumber = this.currentRotatedNumber;
    }

    // Dispatch event for zapballoon.js
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('whatsapp_number_updated'));
    }
  }

  isLP2(): boolean {
    return this.router.url.includes('-2');
  }
}
